import React from 'react';
import { useTranslation } from 'react-i18next';
import { s } from '../helpers';

export interface KpiItem {
  id: string;
  icon: string;
  label: string;
  tip: string;
  valueText: string;
  deltaText: string;
  color: string;
  arrow: string;
  onClick: () => void;
  tipOpen: boolean;
  onEnter: () => void;
  onLeave: () => void;
  gridCol?: string;
  isWide?: boolean;
}

export interface KpiCardsProps {
  kpis: KpiItem[];
  kpiCols: string;
  kpiValSize: string;
}

export const KpiCards: React.FC<KpiCardsProps> = ({ kpis, kpiCols, kpiValSize }) => {
  const { t } = useTranslation();

  return (
    <div style={s(`display:grid;grid-template-columns:${kpiCols};gap:8px;min-width:0`)}>
      {kpis?.map((k, k_idx) => (
        <React.Fragment key={k_idx}>
          <div
            onClick={k.onClick}
            style={s(
              `position:relative;cursor:pointer;background:#FFFEFB;border:1px solid #EFE6D6;border-radius:12px;box-shadow:0 1px 3px rgba(120,90,30,0.06);padding:12px ${k.isWide ? '12px' : '10px'};display:flex;gap:8px;align-items:flex-start;min-width:0${k.gridCol ? `;grid-column:${k.gridCol}` : ''}`
            )}
          >
            <i
              className={`icon-${k.icon}`}
              style={s(`font-size:26px;color:#B8893A;flex:none;line-height:1;margin-top:2px`)}
            ></i>
            <div style={s(`display:flex;flex-direction:column;gap:3px;min-width:0;flex:1;overflow:hidden`)}>
              <span
                style={s(
                  `font-size:${kpiValSize};font-weight:700;color:#1B1B1B;letter-spacing:-0.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:1.15`
                )}
              >
                {k.valueText}
              </span>
              <span
                style={s(
                  `font-size:10px;font-weight:600;color:#3A342C;text-transform:uppercase;letter-spacing:0.02em;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis`
                )}
                title={k.label}
              >
                {k.label}
              </span>
              <span
                style={s(
                  `display:flex;align-items:center;gap:3px;color:${k.color};font-weight:600;font-size:11px;margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis`
                )}
              >
                <i className={`icon-${k.arrow}`} style={s(`font-size:10px;flex:none`)}></i>
                <span style={s(`overflow:hidden;text-overflow:ellipsis`)}>{k.deltaText}</span>
              </span>
              <span style={s(`font-size:10px;color:#8A8278;white-space:nowrap;overflow:hidden;text-overflow:ellipsis`)}>
                {t('managerNetwork.kpi.vsPreviousPeriod', 'so với kỳ trước')}
              </span>
            </div>
            <span
              onMouseEnter={k.onEnter}
              onMouseLeave={k.onLeave}
              style={s(`position:absolute;top:6px;right:6px;color:#CFC4B2;font-size:12px;cursor:help;display:flex`)}
            >
              <i className="icon-info"></i>
            </span>
            {Boolean(k.tipOpen) && (
              <div
                style={s(
                  `position:absolute;top:26px;right:4px;width:230px;z-index:20;background:#2A2419;color:#fff;font-size:12px;line-height:1.45;padding:10px 12px;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,0.2)`
                )}
              >
                {k.tip}
              </div>
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
